
  import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
  import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
  import { ErrorBase } from 'base-models';
  import { ErrorcontrolService } from 'basecomponents';
  import { Observable } from 'rxjs';
import { Site } from 'solar-bo';
import { SolarService } from '../../services/solarservice.service';

@Component({
  selector: 'app-site-filter',
  templateUrl: './site-filter.component.html',
  styleUrls: ['./site-filter.component.scss']
})
export class SiteFilterComponent implements OnInit,OnDestroy {
  
    @Input() myplaceholder: string = "Placeholder";
    @Input() mylist: any[] = [0];
    @Input() includeall: boolean = true;
    @Input() includeall_text: string = "All";
    @Input() selectfirst: boolean = false;
    /**
     * id fo selected item
     */
    @Input() selecteditem:any = -1;
    @Input() automaticLoad:boolean=true;
  
    @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
    @Output() onSiteSelected: EventEmitter<any> = new EventEmitter();
    @ViewChild('filterby', {static: false}) filterbysite: MatSelect;
  
    constructor(public baseService: SolarService

    ) {
  
    }
    ngOnInit() {
      if (this.automaticLoad){
        this.getList();
      }

    }

    ngOnDestroy(){

    }
  
    getSelectBy() {
      /* let returnvalue:any= this.filterbyproperty.selected;//in this case we expect always one item
      return returnvalue.value; */
      return this.selecteditem;
    }

    
  
    changeitem(event) {
      console.log("changeitem",event.value);
      this.selecteditem = event.value;
      this.onFilterChange.emit(this.selecteditem);
      this.notifySelectedItem(event.value);
    }

    notifySelectedItem(id){
      let site=this.mylist.find(item=>item.id==id);
      if (site){
        this.onSiteSelected.emit(site);
      }
    }

    selectItemById(id_site){
      this.selecteditem=id_site;
    }
  
    getList(): void {
      this.baseService.sitesGetAll()
        .subscribe(
          elements => this.handleresult(elements)
          , err => this.handleError(err)
        );
    }
  
    handleresult(listresult: Site[]) {

      if (this.includeall == true) {
  
      } else {
        let index = listresult.findIndex(d => d.id === '-1');
        if (index != -1) {
          listresult.splice(index, 1);
        }
  
      }

      this.mylist = listresult;

      if (this.selectfirst) {
        if (listresult.length > 0) {
          this.selecteditem = listresult[0].id;
        }
      }else if (this.selecteditem!='-1'){
        this.onFilterChange.emit(this.selecteditem);
        this.notifySelectedItem(this.selecteditem);
      }

    }
  
    handleError<T>(err: any) {
      let errbase: ErrorBase = ErrorcontrolService.getListhandleError(err);
     }
  
  }
  
